import react from "react"

export const onUpdateFCMToken = async (accessToken, memberId, currentToken) => {
  console.log(accessToken)

  console.log(memberId)

  console.log(currentToken)
  // Use functional component or custom hook to access useStores

  await fetch(`${process.env.API_URL}/api/member/token`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${accessToken}`,
    },
    body: JSON.stringify({
      member_id: memberId,
      fcm_token: currentToken,
    }),
  })
    .then(async (res) => {
      if (res?.ok) {
        console.log("success update fcm")
      }
    })
    .catch((e) => console.log(e, "error update fcm"))
}
